import classNames from 'clsx';
import React from 'react';

import Translation from '@swf/components/Translation/Translation';

import styles from './TutorialItem.scss';

export interface Props {
  icon: JSX.Element;
  text: {
    id: string;
    defaultMessage: string;
  };
}

const TutorialItem: React.FC<Props> = ({ icon, text }) => (
  <div className={classNames(styles.box)}>
    <div className={classNames(styles.boxIcon)}>{icon}</div>
    <div className={classNames(styles.boxText)}>
      <Translation {...text} />
    </div>
  </div>
);

export default TutorialItem;
